import * as React from 'react';

function SvgFiltersIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 22" {...props}>
      <path
        fill="#fff"
        d="M7.642 18.071H19v1.572H7.642zm-5.54.786L.007 20.884 1.152 22l3.245-3.143-3.245-3.143L0 16.822zm5.54-8.643H19v1.572H7.642zM2.102 11 .007 13.027l1.144 1.116L4.397 11 1.152 7.857 0 8.965zm5.54-8.643H19V3.93H7.642zm-5.54.786L.007 5.17l1.144 1.116 3.245-3.143L1.152 0 0 1.108z"
      />
    </svg>
  );
}
export default SvgFiltersIcon;
